import React from 'react';

const SimulatorShowcase = () => {
  return (
    <section className="home-section-tight">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center gap-10 sm:gap-12 lg:flex-row lg:gap-20">
          <div className="flex-1 max-w-xl order-2 lg:order-1">
            <span className="home-kicker mb-4 block">The Interface</span>
            <h2 className="mb-5 text-3xl font-bold tracking-tight text-white md:mb-6 md:text-5xl">Four surfaces. One learning loop.</h2>
            <p className="home-body mb-8 max-w-xl">
              The learner is never only reading, never only looking, and never only adjusting sliders. The interface links a 3D viewport, a parameter panel, a status readout, and a visualization area  -  so you are always moving between setup, action, result, and interpretation. That mirrors the actual logic of experimental science.
            </p>
            <ul className="mb-8 space-y-3 font-mono text-xs text-gray-400 sm:text-sm md:space-y-4">
              <li className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-pulse"></span>
                <span>Seven studies: scattering, Bragg peak, Cherenkov, spectrometer, TRD, tomography, and muon g-2</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 bg-pink-400 rounded-full animate-pulse delay-75"></span>
                <span>A guide layer that scaffolds learning  -  reacting to runs and nudging the next useful question</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 bg-lime-400 rounded-full animate-pulse delay-150"></span>
                <span>Distributions, not single answers  -  physics knowledge emerges from spreads, peaks, and fluctuations</span>
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-3 sm:gap-4">
              <a href="https://simulator.virtualbeamline.org" target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-8 py-3 font-bold text-black shadow-[0_0_15px_rgba(255,255,255,0.2)] transition-all hover:scale-105 hover:bg-gray-200 sm:w-auto">
                Launch Simulator
              </a>
              <span className="basis-full text-[10px] font-mono uppercase tracking-[0.2em] text-white/25 sm:basis-auto sm:text-xs sm:tracking-[0.24em]">Preview of the simulation interface</span>
            </div>
          </div>
          
          <div className="flex-1 w-full relative group order-1 lg:order-2">
            <div className="absolute -inset-1 bg-cyan-400/20 rounded-lg blur opacity-0 group-hover:opacity-100 transition duration-500 group-hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]"></div>
            <div className="relative overflow-hidden rounded-lg transition-all duration-500 group-hover:-translate-y-2">
              <img
                src="/images/pic1.jpg"
                alt="Student using the simulator on a tablet"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SimulatorShowcase;
